/**
 * @file pages.js
 * @description 页面路径配置
 */

const webPrefix = '/community/';
export const webPages = {
    home: webPrefix,
    homeTab: webPrefix + 'topic/list',
    list: webPrefix + 'topic/list2',
    issueList: webPrefix + 'issue/list',
    addTopic: webPrefix + 'topic/add',
    editTopic: webPrefix + 'topic/edit',
    topicContent: webPrefix + 'topic/show',
    issueContent: webPrefix + 'issue/show',
    search: webPrefix + 'search',
    userInfo: webPrefix + 'user/info'
};
